
export class ModalResult<TResult> {
  constructor(public result: TResult, public cancel = false) { }
}
